import { SOCIAL_LINKS } from '../../../lib/seo';

/**
 * "Follow us" box in the article sidebar.
 *
 * The template version hardcoded follower counts (34,456 متابع and friends)
 * next to links pointing at `https://facebook.com` — the platform home page,
 * not a Telesafi profile. Invented audience figures on a news site are a trust
 * problem before they are an SEO one, and the bare platform links passed link
 * equity off-site for nothing. Both are gone: the box renders only once real
 * profile URLs exist in SOCIAL_LINKS, and it states no number it cannot back
 * up.
 */
export function ArticleSocialFollow() {
  if (SOCIAL_LINKS.length === 0) return null;
  return (
    <div className="trending-social mt-3">
      <div className="section-title">
        <h3 className="title">تابعونا</h3>
      </div>
      <ul>
        {SOCIAL_LINKS.map((s) => (
          <li key={s.name}>
            <a href={s.url} target="_blank" rel="noopener noreferrer me">
              <i className={s.icon} aria-hidden="true" />
              <span>{s.label}</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
